import { AudioPlayer } from '#components'
import { getData } from './data'

export const useAudioPlayer = createSharedComposable(() => {
  const data = getData()
  const url = data.audio.audioUrl
  const currentTime = ref(0)

  /** Native audio element */
  const audioRef = ref<HTMLAudioElement>()

  /** AudioPlayer component */
  const Player = defineComponent((props, ctx) => {
    return () => h(AudioPlayer, {
      url,
      audioRef: audioRef as any,
      peaks: data.audio.peaks,

      onVnodeBeforeMount() {
        audioRef.value = new Audio(url)
      },

      onVnodeBeforeUnmount() {
        getAudio().pause()
      }
    }, ctx.slots)
  })

  function getAudio() {
    const ref = audioRef.value

    if (!import.meta.client)
      throw new Error('Tried to get audio in server side. This is only supported in client-side code')

    if (!ref)
      throw new Error('audioRef not found. Maybe element not attached')

    return ref
  }

  function updatePlaybackRate(value: number = 1) {
    getAudio().playbackRate = value
  }

  useEventListener(audioRef, 'timeupdate', () => {
    currentTime.value = audioRef.value?.currentTime ?? 0
  })

  return {
    currentTime,
    Player,
    getAudio,

    get audio() {
      return getAudio()
    },

    updatePlaybackRate
  }
})
